var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 0V5L3.17174 3.17141C2.44778 3.89528 2 4.89535 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 4.13643 8.7256 2.57052 7.00076 2.12621L7.00081 0.0830939C9.83812 0.559504 12 3.02729 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 4.34309 0.671622 2.84304 1.75748 1.75724L0 0H5Z","fill":"white"}));
}

Refresh.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Refresh;

Refresh.default = Refresh;
